

import React, { useEffect, useRef, useState } from 'react'
import { Link } from "react-router-dom";
import LogoTopLeft from "../images/LogoTopLeft.png";
import FacebookIcon from "../images/facebook_icon.png";
import InstagramIcon from "../images/instagram_icon.png";
import TwitterIcon from "../images/twitter_idcon.png";
import ShoppingCartIcon from "../images/ShoppingCartIcon.png";

const KondoHeader = () => {

    const [isOpenMenu, setIsOpenMenu] = React.useState(false);

    const [count, setCount] = useState(0);
    useEffect(() => {
        console.log("Hello hooks");
        setIsOpenMenu(false);
    }, []);

    useEffect(() => {
        console.log("Hello hooks");
        
    }, [count]);
    
    const handleOnClick = () => {
        setCount(count + 1);
        if(!isOpenMenu){
            console.log(isOpenMenu);
            setIsOpenMenu(true);
            setTimeout(() => {
                document.getElementById('g-nav-ul').style.display = 'flex';
                document.getElementById('g-nav-ul').style.opacity = '1';  
            }, 200);
        }else{
            console.log(isOpenMenu);
            setIsOpenMenu(false);
            document.getElementById('g-nav-ul').style.display = 'none';
            setTimeout(() => {
                document.getElementById('g-nav-ul').style.display = 'flex';
                document.getElementById('g-nav-ul').style.opacity = 'none';  
            }, 200);
            document.getElementById('g-nav-ul').style.opacity = '0';
        }
        var windowWidth = window.innerWidth;
        var windowSm = 1980;
        if (windowWidth <= windowSm) {
            document.getElementById('target')?.classList.toggle('active');
            document.getElementById('g-nav')?.classList.toggle('panelactive');
        } else {
            document.getElementById('g_nav_list')?.classList.toggle('g-wlarge-nav-list');
            document.getElementById('g_nav_list').addEventListener('mouseover', () => {
                console.log("mousehover");
            }, false);
            document.getElementsByClassName("hover-listen-class")?.addEventListener('mouseleave', () => {
                console.log("mouseleave");
            }, false);
        }
        console.log("count = ", count);
    };

    return(
        <div className='header05' id='header'>
            <nav>
                <ul className='ul-left'>
                    <div>
                        <Link to='/'>
                                <img src={LogoTopLeft} alt='トップアイコン' />                
                        </Link>
                    </div>
                    <Link to='/article'>
                        <li id="01">染の心</li>
                    </Link>
                    <Link to="/product">
                        <li>商品紹介</li>
                    </Link>
                    <Link to='/company'>
                        <li>会社案内</li>
                    </Link>
                    <Link to="/news">
                        <li>お知らせ</li>
                    </Link>
                    <Link to="/contact">
                        <li>お問い合せ</li>
                    </Link>
                </ul>
                <ul className='ul-right'>
                    <li>
                        <a href='https://www.facebook.com/kondosome'>
                            <img src={FacebookIcon} alt='facebookアイコン' className='header-icon' />
                        </a>   
                    </li>
                    <li>
                        <a href='https://www.instagram.com/konsome2255/'>
                            <img src={InstagramIcon} alt='instagramアイコン' className='header-icon' />
                        </a>   
                    </li>
                    <li>
                        <a href='https://twitter.com/konsome38195981'>
                            <img src={TwitterIcon} alt='twitterアイコン' className='header-icon' />
                        </a>   
                    </li>
                    <a href='https://kondo.shop-pro.jp/'>
                        <li className='ul-header-shop'>
                            <img src={ShoppingCartIcon} alt="オンラインショップ" />
                            オンラインショップ
                        </li>
                    </a>
                    <li onClick={() => handleOnClick()}>
                        <div className="open-hmb-btm" id="target"><div className="openbtn-area"><span></span><span></span><span></span></div></div>
                    </li>
                </ul>
            </nav>
            <nav id="g-nav">
                <div id="g-nav-list" className='hover-listen-class'>
                    <ul id="g-nav-ul">
                        <li><Link to='/article' className='nav-wbig-none'>染の心</Link></li>   
                        <li>
                            <Link to="/product" className='nav-wbig-none'>商品紹介</Link>
                            <div className = "list">
                                <a href='http://www.kondo-some.co.jp/lineup/tairyou.html'> 
                                    <li><span>- 大漁旗</span></li>
                                </a>
                                <a href='http://www.kondo-some.co.jp/lineup/noren.html'>
                                    <li><span>- のれん</span></li>
                                </a>
                                <a href='http://www.kondo-some.co.jp/lineup/hanten.html'>
                                    <li><span>- はんてん</span></li>
                                </a>
                                <a href='http://www.kondo-some.co.jp/lineup/kaiki.html'>
                                <li><span>- 会旗</span></li>
                                </a>
                                <a href='http://www.kondo-some.co.jp/lineup/nobori.html'>
                                    <li><span>- のぼり</span></li>
                                </a>
                                <a href='http://www.kondo-some.co.jp/lineup/jinjya.html'>
                                    <li><span>- 神社</span></li>
                                </a>
                                <a href='http://kondo.shop-pro.jp/'>
                                    <li><span>- 染製品</span></li>
                                </a>
                                <a href='http://www.kondo-some.co.jp/gift/'>
                                    <li><span>- ご贈答品</span></li>
                                </a>
                            </div>
                        </li>  
                        <li>
                            <Link to='/company' className='nav-wbig-none'>会社案内</Link>
                            <div className = "list">
                                <Link to='/company'>
                                    <li><span>- 会社概要</span></li>
                                </Link>
                                <Link to='/story'>
                                    <li><span>- いまむかし</span></li>
                                </Link>
                            </div>
                        </li>
                        <li><Link to='/news' className='nav-wbig-none'>お知らせ</Link></li>
                       
                        <li>
                            <Link to="/contact" className='nav-wbig-none'>
                                お問い合せ
                            </Link>
                            <div className = "list">
                                <Link to="/privacypolicy"> 
                                    <li className='nav-li-privacy'><span>- 個人情報の取り扱い</span></li>
                                </Link>
                            </div>
                        </li>
                        <li>
                            <a href='https://kondo.shop-pro.jp/' className='nav-online-store'>
                                <img src={ShoppingCartIcon} alt="オンラインショップ" style={{width: "15px"}}/>
                                オンラインショップ
                            </a>
                        </li>
                        <ol>
                            <li>
                                <a href='https://www.facebook.com/kondosome' className='nav-icon'>
                                    <img src={FacebookIcon} alt='facebookアイコン' className='header-icon' style={{width: "20px"}} />
                                </a>   
                            </li>
                            <li>
                                <a href='https://www.instagram.com/konsome2255/' className='nav-icon'>
                                    <img src={InstagramIcon} alt='instagramアイコン' className='header-icon' style={{width: "20px"}} />
                                </a>   
                            </li>
                            <li>
                                <a href='https://twitter.com/konsome38195981' className='nav-icon'>
                                    <img src={TwitterIcon} alt='twitterアイコン' className='header-icon' style={{width: "20px"}} />
                                </a>   
                            </li>
                        </ol>
                    </ul>
                    
                </div>
            </nav>
        </div>
    )
}
export default KondoHeader;